import React, { useState } from 'react';

const options = [
  { value: 1, label: 'Initiating' },
  { value: 2, label: 'Emerging' },
  { value: 3, label: 'Performing' },
  { value: 4, label: 'Advancing' },
  { value: 5, label: 'Leading' },
];

const getLevelValue = (label) => {
  const found = options.find((opt) => opt.label === label);
  return found ? found.value : 0;
};


const MaturityScale = ({ lableValue=false, currentLevel, targetLevel, optionLabel }) => {

  let currentLevelValue;
  let targetLevelValue;

  if (lableValue === true) {
    currentLevelValue = getLevelValue(currentLevel);
    targetLevelValue = getLevelValue(targetLevel);
  } else {
    currentLevelValue = Math.round(currentLevel);
    targetLevelValue = Math.round(targetLevel);
  }


console.log('lableValue',lableValue);

console.log('targetLevelValue',targetLevelValue);

  return (
    <div className="custom_dual_container">
      {/* Top Progress Bar (Current) */}
      <div className="custom_progress_bar_wrapper">
        <div className="custom_progress_bar">
          {options.map((opt) => (
            <div key={`bar-top-${opt.label}`} className={`custom_bar_segment ${opt.value <= currentLevelValue ? "filled" : ""
              }`}>
              <div className="custom_tick custom_top_tick" />
              {currentLevelValue === opt.value && (
                
                <div className="custom_marker custom_top"><span>Current</span> <span>{lableValue == false ? currentLevel.toFixed(3) : 'Current'}</span>  </div>
              )}
              {/* <div className="custom_tick custom_bottom_tick" /> */}
            </div>
          ))}
        </div>
      </div>

      {/* Shared Center Options Row */}
      {optionLabel && (
        <div className="custom_options_center_row">
          {options.map((opt) => (
            <div key={`center-${opt.value}`} className="custom_option_label">
              {opt.value} - {opt.label}
            </div>
          ))}
        </div>
      )}

      {/* Bottom Progress Bar (Target) */}
      <div className="custom_progress_bar_wrapper">
        <div className="custom_progress_bar">
          {options.map((opt) => (
            <div
              key={`bar-bottom-${opt.label}`}
              className={`custom_bar_segment ${opt.value <= targetLevelValue ? "filled" : ""
                }`}
            >
              <div className="custom_tick custom_top_tick" />

              {targetLevelValue === opt.value && (
                <div className="custom_marker custom_bottom" ><span>Target</span>   <span>{lableValue == false ? targetLevel.toFixed(3) : 'Target'}</span></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MaturityScale;
